// extracted by mini-css-extract-plugin
module.exports =  {"rate":"da51a739f7--rate--yyMtS","logo":"da51a739f7--logo--Ertc4","row":"da51a739f7--row--YWUmp"};